import React from 'react';
import { Link } from 'react-router-dom';
import HamburgerMenu from './HamburgerMenu';

const Header: React.FC = () => {
  return (
    <header>
      <Link to="/" aria-label="HICO home"><span className="logo-text">Hico.dev</span></Link>
      <HamburgerMenu />
    </header>
  );
};

export default Header;
